import React, { useState, useEffect } from "react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "../../../utils/builder";

export const ProductCarouselSection = ({
  builderTargetingData,
  basketPage,
}) => {
  const [builderContentJson, setBuilderContentJson] = useState(null);

  useEffect(() => {
    builderClient
      .get("product-carousel", {
        userAttributes: {
          ...builderTargetingData,
          basketPage: basketPage,
        },
      })
      .promise()
      .then(setBuilderContentJson);
  }, []);
  return (
    <BuilderComponent model="product-carousel" content={builderContentJson} />
  );
};
export default ProductCarouselSection;
